<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.labResults', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @reset="onReset" v-if="show">
                    <b-row>
                        <b-col sm="12">
                            <b-form-group
                                id="patient-group"
                                :label="$tc('message.praticien',1)"
                                label-for="patient">
                                <select id="praticien" v-model="$v.form.praticien.$model"
                                    @change="clearErrorField('praticien')" required>
                                    <option data-placeholder="true"></option>
                                    <option v-for="item in mPractitioners" :key="item.id" :value="item.id">
                                        {{ item.nom }}
                                    </option>
                                </select> 
                                <b-form-invalid-feedback>
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <span v-if="errorshasField('praticien')" style="color:red">
                                    {{getErrorsField('praticien')}}
                                </span>

                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>

                            <b-form-group
                                    id="consultation-group"
                                    :label="$t('message.typeResultat')"
                                    label-for="consultation">
                                <b-form-input id="consultation" v-model="$v.form.consultation.$model" type="text" placeholder="Type de Résultat" :state="$v.form.consultation.$dirty ? !(errorshasField('consultation') || $v.form.consultation.$error) : null" required></b-form-input>
                                
                                <b-form-invalid-feedback v-if="$v.form.consultation.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-if="errorshasField('typeResultat')">
                                    {{ getErrorsField('typeResultat') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                        <!-- <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="consultation-group"
                                    :label="$tc('message.generalConsultations', 1)"
                                    label-for="consultation">

                                <select id="consultation"  v-model="$v.form.consultation_medecine_generale_id.$model"
                                        @change="clearErrorField('consultation_medecine_generale_id')"
                                        :state="$v.form.consultation_medecine_generale_id.$dirty ? !(errorshasField('consultation_medecine_generale_id') || $v.form.consultation_medecine_generale_id.$error) : null"
                                        required
                                        class="form-control is-invalid retirerBordure"
                                >
                                    <option data-placeholder="true"></option>
                                    <option v-for="item in mConsultations"  :key="item.value" :value="item.value">
                                        {{ item.text }}
                                    </option>
                                </select>
                                <b-form-invalid-feedback v-if="$v.form.consultation_medecine_generale_id.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('consultation_medecine_generale_id')">
                                    {{ getErrorsField('consultation_medecine_generale_id') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col> -->

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="description-group"
                                    :label="$t('message.description')"
                                    label-for="description">
                                <b-form-textarea
                                    id="description"
                                    v-model="$v.form.description.$model"
                                    :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                    required
                                    @focus="clearErrorField('description')"
                                ></b-form-textarea>

                                <b-form-invalid-feedback v-if="!$v.form.description.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-if="!$v.form.description.minLength">
                                    {{ $t('message.minCharacters', { n: 3 }) }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                    {{ getErrorsField('description') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="date-group"
                                    :label="$tc('message.dates', 1)"
                                    label-for="date"
                            >
                                <b-form-input
                                        id="date"
                                        v-model="$v.form.date.$model"
                                        :state="$v.form.date.$dirty ? !(errorshasField('date') || $v.form.date.$error) : null"
                                        type="date"
                                        required
                                        @focus="clearErrorField('date')"
                                ></b-form-input>

                                <b-form-invalid-feedback v-if="!$v.form.date.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('date')">
                                    {{ getErrorsField('date') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <b-form-group
                                    id="upload-group"
                                    :label="$t('message.uploadFile')"
                                    label-for="upload"
                            >
                                <b-form-file
                                        id="upload"
                                        :state="$v.form.file.$dirty ? !$v.form.file.$error : null"
                                        :placeholder="$t('message.uploadFile')"
                                        :file-name-formatter="formatNames"
                                        @change="setImage"
                                ></b-form-file>

                                <b-form-invalid-feedback>
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span >{{fileSize}} </span> <span v-if="sizeError" style="color: red">{{$t('message.tailleMaximum')}}</span>
                            </b-form-group>
                        </b-col>

<!--                        <b-col sm="12">-->
<!--                            <b-container fluid class="p-4">-->
<!--                                <b-row id="image">-->
<!--                                    <b-col>-->
<!--                                        <b-img-lazy-->
<!--                                                class="img-preview"-->
<!--                                                thumbnail-->
<!--                                                :src="imageSrc(form.file)"-->
<!--                                                fluid-grow-->
<!--                                                alt=""-->
<!--                                        ></b-img-lazy>-->
<!--                                    </b-col>-->
<!--                                </b-row>-->
<!--                            </b-container>-->
<!--                        </b-col>-->
                    </b-row>

                    <b-row class="justify-content-sm-center" v-if="can">
                        <b-button @click="onSubmit" variant="primary">
                            {{ $t('message.edit') }}
                        </b-button>

<!--                        <b-button type="reset" variant="danger">-->
<!--                            {{ $t('message.reset') }}-->
<!--                        </b-button>-->
                    </b-row>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import AppConfig from '../../../constants/AppConfig';
    import SlimSelect from "slim-select";


    export default {
        name: "EditResultat",

        computed: {
            ...mapGetters(["result", "files", "errors", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante", "practitioners"]),

            form: function() {
                return {...this.result, consultation: this.result.consultation_medecine_generale_id, praticien: this.result.praticien_id };
            },

             mPractitioners: function() {
                let pArray = [];

                _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
                    let p = {};
                    // if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure == '1'){
                    if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && ((practitioner.user.isMedicasure == '0' || practitioner.user.isNotice == '1') || (practitioner.user.isMedicasure || practitioner.user.isNotice == '1'))){
                    // console.log('practitioner.user.isMedicasure => ', practitioner.user.nom);
                    let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
                    prenom =  prenom.toLowerCase();
                    p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    p.id = practitioner.user.id;
                    if (p.nom.length >0){
                        pArray.push(p);
                    }
                    }

                });
                return pArray;
            },


            mFiles: function() {
                let fArray = [];

                // _.forEach(this.files, function(file) {
                if(!_.isUndefined(this.form.dossier)){
                    if(!_.isNull(this.form.dossier)){
                        let file = this.form.dossier;
                        let user = file.patient.user;

                        let nom = user.nom + ((user.prenom != null && user.prenom) ? (' ' + user.prenom) : '');
                        let dossier = file.numero_dossier;

                        let text = nom + ' - ' + dossier;

                        fArray.push({ text, value: file.id });
                    }

                }
                // });
                return fArray;
            },

            can: function () {
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            }
        },

        data() {
            return {
                result_id: this.$route.params.result,
                show: true,
                fileSize:'0 Mo',
                sizeError:false,
            }
        },

        methods: {
            getResult: function() {
                let args = {
                    result: this.result_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getLabResult', { args, errorMessages });
            },

            getConsultations: function() {
                let args = {};

                this.$store.dispatch('getGeneralConsultations', { args });
            },

            getPractitioners() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getPractitioners', { args : args });
            },

            getMedicalFiles: function() {
                let args = {};

                this.$store.dispatch('getMedicalFiles', { args });
            },

            formatNames(files) {
                if (!_.isEmpty(files)){
                    this.fileSize  =  this.formatBytes(files[0].size,2);
                }else{
                    this.fileSize = '0 MB';
                }
                return files[0].name
            },

            setImage(event) {
                this.form.file = event.target.files[0];
            },

            imageSrc(img) {
                if (img) {
                    try {
                        return URL.createObjectURL(img);
                    } catch(e) {
                        return AppConfig.imgUrl + '/public/storage/' + img;
                    }
                }

                return '';
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid && !this.sizeError) {

                    /*let args = {
                        result: this.result_id,
                        consultation_medecine_generale_id: this.form.consultation_medecine_generale_id,
                        dossier_medical_id: this.form.dossier_medical_id,
                        description: this.form.description,
                        date: this.form.date,
                        file: this.form.file
                    };*/

                    let formData = new FormData();


                    formData.append('consultation_medecine_generale_id', this.form.consultation);
                    formData.append('dossier_medical_id', this.form.dossier_medical_id);
                    formData.append('praticien_id', this.form.praticien);
                    formData.append('description', this.form.description);
                    formData.append('date', this.form.date);
                    formData.append('file', this.form.file);

                    let successMessage = this.$i18n.t('message.resultUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateLabResult', { args: formData, result: this.result_id, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.consultation_medecine_generale_id = '';
                this.form.dossier_medical_id = '';
                this.form.description = '';
                this.form.date = '';
                this.form.file = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors.hasOwnProperty(field);
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
            formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return '0 Bytes';

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));

                let size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm))
                let type =  sizes[i] ;

                if (i >=2 && size >= 5){
                    this.sizeError = true;
                }else {
                    this.sizeError = false;
                }
                return size + ' '+type;

            }
        },

        validations: {
            form: {
                praticien: {
                    required
                },
                consultation: {
                    required
                },
                consultation_medecine_generale_id: {
                    required
                },
                dossier_medical_id: {
                    required
                },
                description: {
                    required,
                    minLength:minLength(3)
                },
                date: {
                    required
                },
                file: {
                    // required
                }
            }
        },

        mounted() {
            // Retrieve result
            this.getResult();

            this.getPractitioners();

            // // Retrieve general consultation list
            // this.getConsultations();
            //
            // // Retrieve medical file list
            // this.getMedicalFiles();


              new SlimSelect({
                select: '#praticien',
                placeholder: 'Sélection du praticien',

            });
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');

</style>